<template>
  <div class="bgmusic">
    <div class="bgan">
      <p @click="bgmusicplay" v-if="isbgmusic == false">
        <img src="../../assets/images/bgmusic1.png" />
      </p>
      <p @click="bgmusicplay" v-else>
        <img src="../../assets/images/bgmusic2.png" />
      </p>
    </div>

    <div class="audio">
      <!--隐藏audio标签-->
      <!-- 音乐 -->
       <!-- src="http://music.163.com/song/media/outer/url?id=447925558.mp3" -->
      <audio
        src="../../assets/11.mp3"
        id="bg_music"
        controls="controls"
        loop 
        autoplay="true"
        preload
        hidden 
      ></audio>
    </div>
  </div>
</template>

<script>
import "../../assets/css/index.css";

export default {
  name: "bgmusic",
  data() {
    return {
      isbgmusic: false,
    };
  },
  mounted() {
    bgmusicplay();
  },
  methods: {
    //音乐点击播放
    bgmusicplay() {
      var audiobg = document.getElementById("bg_music");
      this.isbgmusic = !this.isbgmusic;
      if (audiobg.paused) {
        audiobg.play();
      } else {
        audiobg.pause();
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/bgmusic/bgmusic.vue